<template lang="pug">
  include ./../../mixins
  +b.order
    +b.H2.caption.--size_2 {{ _("Create the order") }}
    +e.content
      +b.ug-row.--offset_sm
        +b.ug-cell.ug-cols.--6-sm.--4-lg
          +b.P.text.--fs_md.--color_black {{ _("Prepayment:") }}
            | 
            +b.SPAN.text.--fs_md.--color_black.--fw_bold {{ defaultData.prepayment }}
        +b.ug-cell.ug-cols.--6-sm.--4-lg
          +b.P.text.--fs_md.--color_black {{ _("Final Prepayment:") }}
            | 
            +b.SPAN.text.--fs_md.--color_black.--fw_bold {{ defaultData.finalprepayment }}
        +b.ug-cell.ug-cols.--6-sm.--4-lg
          +b.P.text.--fs_md.--color_black {{ _("Total Price:") }}
            | 
            +b.SPAN.text.--fs_md.--color_black.--fw_bold {{ defaultData.price }}
    +e.content
      validation-observer(
        tag="form"
        ref="observer"
        v-slot="props"
        @submit.prevent="validateBeforeSubmit"
      )
        +b.ug-row.--offset_sm
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="date_at"
            )
              +b.control
                +e.elements
                  +b.FLAT-PICKER.control-input(
                    value='',
                    placeholder="",
                    name='date_at',
                    type="date",
                    v-model='formdata.date_at',
                    :config="configDate",
                    :class="{'flatpickr-input is-error': errors[0] }"
                  )
                  +e.label(:class='{"is-active": formdata.date_at}')
                    label {{ _("Date") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              :rules="{required: true, oneHour: formdata.date_at}"
              name="time"
            )
              +b.control
                +e.elements
                  +b.FLAT-PICKER.control-input(
                    value='',
                    placeholder="",
                    name='time',
                    type="time",
                    v-model='formdata.time',
                    :config="configTime",
                    :class="{'flatpickr-input is-error': errors[0] }"
                  )
                  +e.label(:class='{"is-active": formdata.time}')
                    label {{ _("Time") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              :rules="{max: 250}"
              name="comment"
            )
              +b.control
                +e.elements
                  +b.control-input.--textarea
                    +b.TEXTAREA.control-textarea(
                      v-model='formdata.comment',
                      name='comment',
                    )
                  +e.label(:class= "{'is-active': formdata.comment.length > 0}")
                    label {{ _("Comment") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols
            +b.ug-row.--offset_sm.--justification_flexend
              +b.ug-cell.ug-cols.--6-sm
                +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Generate order") }}
</template>

<script>

import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'

export default {
  props: {
    url: String,
    priceInfo: Object
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      defaultData: {
        prepayment: '',
        finalprepayment: '',
        price: '',
      },
      formdata: {
        comment: '',
        'date_at': '',
        time: '',
      },
      configDate: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      configTime: {
        dateFormat: "H:i",
        enableTime: true,
        noCalendar: true,
        minDate: "today",
        'time_24hr': true
      },
    }
  },
  mounted() {
    this.fillDefaultData()
  },
  methods: {
    fillDefaultData() {
      Object.keys(this.priceInfo).forEach(key => {
        this.defaultData[key] = this.priceInfo[key]
      })
      const { price, prepayment } = this.priceInfo
      this.defaultData['finalprepayment'] = price - prepayment
    },
    send() {
      let formdata = Object.assign({}, this.formdata)
      let prettyDate = `${formdata['date_at']} ${formdata['time']} GMT+0000`.replace(/-/g, "/")
      formdata['date_at'] = new Date(Date.parse(prettyDate)).toISOString()
      this.api.post(this.url, formdata).then(res => {
        let {data} = res
        if (data.link) {
          window.location = data.link
        }
      }).catch(error => {
        let {data} = error.response
        this.showErrors(data)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/Order/UserOrder.vue